import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button, styled, Stack, Typography } from "@mui/material";
import { deleteProduct, loginAdmin } from "../../apiservices";
import { toast } from "react-toastify";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { CustomToolbar } from "../categories/categoryTable";
import CustomDialogue from "../reuseableComp/Modal";
import { Typo } from "../bank";

const Btn = styled(Button)({
  textTransform: "none",
  background: "#EEF4FF",
  color: "#05ae97",
  "&:hover": {
    color: "#000",
    background: "#05ae97",
  },
});

export default function DataTable({
  editProduct,
  data,
  handleCheck,
  getData,
  openDetail,
}) {
  // if (data) {
  // data.forEach((element) => {
  //   element["id"] = element._id;
  // });
  // }
  const [state, setState] = React.useState({
    password: "",
    isDelete: false
  });

  const columns = [
    // { field: "brand_name", headerName: "Brand" },
    // { field: "category_name", headerName: "Category", width: 130},
    { field: "description", headerName: "Products", width: 300 },
    // { field: "modelName", headerName: "Model", width: 150 },
    {
      field: "purchase_price",
      headerName: "Purchase Price",
      width: 150,
    },
    {
      field: "sale_price",
      headerName: "Sale Price",
      sortable: true,
      width: 150,
    },
    // {
    //   field: "opening_qty",
    //   headerName: "Opening Qty",
    //   sortable: true,
    //   width: 150,
    // },
    {
      field: "stock",
      headerName: "Stock",
      sortable: true,
      width: 150,
    },
    {
      field: "stock_amount",
      headerName: "Stock Amount",
      sortable: true,
      width: 150,
    },
    {
      field: "action",
      headerName: "Action",
      width: 250,
      sortable: false,
      renderCell: (params) => (
        <>
          <Btn
            sx={{ height: '30px', mr: '5px', padding: 0 }}
            variant="contained"
            color="primary"
            size="small"
            onClick={() => openDetail(params.row)}>
            Details
          </Btn>
          <Btn
            title="Edit"
            variant="contained"
            sx={{ width: '30px', height: '30px', minWidth: '30px', mr: '5px', padding: 0, background: "#eed202", color: "white" }}
            onClick={() => edit(params.row)}>
            <EditIcon fontSize="small" />
          </Btn>
          <Btn
            title="Delete"
            sx={{ width: '30px', height: '30px', minWidth: '30px', mr: '5px', padding: 0, background: "red", color: "white" }}
            variant="contained"
            onClick={() => deleteRow(params.row)}>
            <DeleteIcon fontSize="small" />
          </Btn>
        </>
      ),
    },
  ];

  const rows = data;
  const edit = (params) => {
    editProduct(params);
    handleCheck();
  };

  const deleteRow = async (params) => {
    setState((prev) => ({
      ...prev,
      isDelete: true,
      id: params.id,
      description: params.description,
    }));
    /* eslint-disable no-restricted-globals */
    // if (confirm(`Are you sure to delete "${params.description}"`)) {
    //   let res = await deleteProduct(params.id);
    //   if (res) {
    //     toast.error("Product deleted successfully");
    //     getData();
    //   }
    // }
  };
  return (
    <div style={{ height: "80vh", width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 20 },
          },
        }}
        pageSizeOptions={[20, 50]}
        components={{
          Toolbar: CustomToolbar,
        }}
      />
      <CustomDialogue
        open={state.isDelete}
        handleClose={() => { }}
        header={
          <Stack justifyContent={"center"} alignItems={"center"}>
            <Typo>Deletion</Typo>
          </Stack>
        }
        content={
          <>
            <Stack sx={{ padding: 1 }}>
              <Stack sx={{ mt: 2 }}>
                <Typography>Please enter password if you really want to delete <strong>
                  {state.description && state.description}
                </strong>.</Typography>
                <input onChange={(e) => {
                  setState((prev) => ({
                    ...prev,
                    password: e.target.value,
                  }));
                }} type="password" />
              </Stack>
            </Stack>
            <div style={{ float: "right" }}>
              <Btn
                sx={{ height: '30px', mt: '10px', mr: '5px', padding: 0, background: "red", color: "white" }}
                variant="contained"
                size="small"
                onClick={async () => {
                  let userData = JSON.parse(localStorage.getItem("user"));
                  let credentials = {
                    username: userData.username,
                    password: state.password,
                  };
                  let resUser = await loginAdmin(credentials);
                  if (resUser.success) {
                    let res = await deleteProduct(state.id);
                    if (res) {
                      toast.error("Product deleted successfully");
                      getData();
                      setState((prev) => ({
                        ...prev,
                        isDelete: false,
                      }));
                    }
                  }
                  else {
                    toast.error("Wrong password...!")
                  }
                }}
              >Delete</Btn>
              <Btn
                sx={{ height: '30px', mt: '10px', mr: '5px', padding: 0 }}
                variant="contained"
                color="error"
                size="small"
                onClick={() => {
                  setState((prev) => ({
                    ...prev,
                    isDelete: false,
                  }));
                }}
              >Close</Btn>
            </div>
          </>
        }
      />
    </div>
  );
}
